"use client";

import AmpService from "analytics/amplitude/amplitudeEvents";
import { RootState } from "interfaces/generics.type";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { b2bUrl } from "util/url/static-urls";

function HomeClient() {
  const { businessCustomer } = useSelector((store: RootState) => store.authenticationState);
  const router = useRouter();

  useEffect(() => {
    // Home page viewed event should fire only for homepage.
    // This component is also being used in src/modules/static-pages/CarParts.tsx
    AmpService.HomePageViewed();
  }, []);

  useEffect(() => {
    if (businessCustomer) {
      router.replace(b2bUrl);
    }
  }, [businessCustomer]);

  return null;
}

export default HomeClient;
